import React, { FormEvent, useEffect } from "react";
import Seo from "components/Seo";
import CustomerLayout from "./customerLayout";
import Input from "../../-components/common/Input";
import Button from "../../-components/common/Button";
import DaumPostcodeEmbed from "react-daum-postcode";
import { useState } from "react";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";
import { ReactComponent as Search } from "assets/morning/icon/search.svg";
import CheckBox from "../../-components/common/Checkbox";
import TrackingPrinter from "assets/morning/tracking-printer.jpeg";
import TrackingLabel from "assets/morning/tracking-label.png";
import TrackingPrinterLabel from "assets/morning/tracking-printer-label.png";
import TrackingInvoice from "assets/morning/tracking-invoice.png";
import TrackingBag from "assets/morning/tracking-bag.png";
import { usePostRegisterTracking } from "../../../../../hooks/morning/usePostRequestTracking";
import { useMorningAuthStore } from "../../../../../store/useMorningAuthStore";
import NoLogin from "../../../common/-pages/service/NoLogin";
import { PatternFormat } from "react-number-format";
import { usePostTrackingHistory } from "hooks/morning/usePostTrackingHistory";
import Spinner from "components/Spinner";
import Table from "components/Table";

const MorningRequestTracking = () => {
    const accessToken = useMorningAuthStore(state => state.accessToken ?? "");
    const c_company = useMorningAuthStore(state => state.c_company);
    const c_director = useMorningAuthStore(state => state.c_director); // 대표자명 (신청 시 함께 저장)

    // 로그인 정보의 c_ex_item1~5(Y/N)와 요청사항 항목을 순서대로 매칭한다. Y인 항목만 노출.
    const c_ex_item1 = useMorningAuthStore(state => state.c_ex_item1);
    const c_ex_item2 = useMorningAuthStore(state => state.c_ex_item2);
    const c_ex_item3 = useMorningAuthStore(state => state.c_ex_item3);
    const c_ex_item4 = useMorningAuthStore(state => state.c_ex_item4);
    const c_ex_item5 = useMorningAuthStore(state => state.c_ex_item5);
    const exItems = [c_ex_item1, c_ex_item2, c_ex_item3, c_ex_item4, c_ex_item5];

    const { mutate: trackingHistory, isPending } = usePostTrackingHistory();
    const [showDepartPostcode, setShowDepartPostcode] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
    const [showCompletePop, setShowCompletePop] = useState<boolean>(false);

    const [filteredHistory, setFilteredistory] = useState<any>();
    const [previewImage, setPreviewImage] = useState<{ src: string; alt: string } | null>(null);
    const [depart, setDepart] = useState({
        company: c_company || "",
        mobile: "",
        printer: false,
        label: false,
        printerLabel: false,
        invoice: false,
        bag: false,
        post: "",
        address: "",
        addressDetail: "",
        contents: "",
    });

    const suppliesOptions: { key: "printer" | "label" | "printerLabel" | "invoice" | "bag"; label: string; image: string; unit: string }[] = [
        { key: "printer", label: "프린터", image: TrackingPrinter, unit: "대" },
        { key: "label", label: "A4스티커라벨지", image: TrackingLabel, unit: "장" },
        { key: "printerLabel", label: "프린터라벨지", image: TrackingPrinterLabel, unit: "장" },
        { key: "invoice", label: "수기송장", image: TrackingInvoice, unit: "장" },
        { key: "bag", label: "봉투", image: TrackingBag, unit: "장" },
    ];

    // c_ex_item이 "Y"인 항목만 노출 (순서대로 매칭)
    const visibleSuppliesOptions = suppliesOptions.filter((_, index) => exItems[index] === "Y");

    // 선택된 요청사항을 기준으로 내용 textarea 텍스트를 구성한다.
    // 사용자가 직접 편집한 수량/메모는 기존 내용에서 파싱하여 보존한다.
    const buildContents = (state: typeof depart, prevContents = "") => {
        const prevLines = prevContents.split("\n");

        const getQty = (label: string) => {
            const line = prevLines.find(l => l.trim().startsWith(`${label} :`));
            if (!line) return "0";
            const after = line.split(":").slice(1).join(":").trim();
            const parts = after.split(/\s+/);
            parts.pop(); // 단위 제거
            return parts.join(" ") || "0";
        };

        const getMemo = () => {
            const line = prevLines.find(l => l.includes("수신처정보(메모):"));
            if (!line) return "";
            return line.split("수신처정보(메모):").slice(1).join("").trim();
        };

        const lines: string[] = [];
        suppliesOptions.forEach(option => {
            if (!state[option.key]) return;
            lines.push(`${option.label} : ${getQty(option.label)} ${option.unit}`);
            if (option.key === "invoice") {
                lines.push(`  > 수신처정보도 타이핑 필요시`);
                lines.push(`     수신처정보(메모): ${getMemo()}`);
            }
        });
        return lines.join("\n");
    };

    const toggleSupply = (key: (typeof suppliesOptions)[number]["key"]) => {
        setDepart(prev => {
            const nextState = { ...prev, [key]: !prev[key] };
            return { ...nextState, contents: buildContents(nextState, prev.contents) };
        });
    };

    const { mutate } = usePostRegisterTracking(prev => {
        setDepart({
            ...prev,
            company: c_company || "",
            mobile: "",
            printer: false,
            label: false,
            printerLabel: false,
            invoice: false,
            bag: false,
            post: "",
            address: "",
            addressDetail: "",
            contents: "",
        });
        setShowCompletePop(true);
        fetchHistory();
    });

    useEffect(() => {
        fetchHistory();
    }, []);

    const fetchHistory = () => {
        trackingHistory(
            { category: "customer_5" },
            {
                onSuccess: res => {
                    // console.log(res); // [{...},{...}]
                    setFilteredistory([...res].slice(0, 5));
                },
                onError: (error: any) => {
                    const message = error.response.data.message;
                    alert(message);
                },
            },
        );
    };

    const handleSubmit = () => {
        const newErrors: { [key: string]: boolean } = {
            company: !depart.company.trim(),
            tel: !depart.mobile.trim(),
            departPostcode: !depart.post.trim(),
            departAddress: !depart.address.trim(),
            departAddressDetail: !depart.addressDetail.trim(),
        };

        setErrors(newErrors);

        const hasError = Object.values(newErrors).some(value => value === true);
        if (hasError) return;

        const payload = {
            category: "customer_5",
            company: depart.company,
            boss: c_director || "", // 대표자명 (로그인 정보에서)
            mobile: depart.mobile,
            printer: depart.printer ? "프린터" : "",
            label: depart.label ? "A4스티커라벨지" : "",
            printerLabel: depart.printerLabel ? "프린터라벨지" : "",
            invoice: depart.invoice ? "수기송장" : "",
            bag: depart.bag ? "봉투" : "",
            post: depart.post,
            address1: depart.address,
            address2: depart.addressDetail,
            contents: depart.contents,
        };

        mutate(payload);
    };

    const handleDepartAddress = (data: any) => {
        let fullAddress = data.address;
        if (data.addressType === "R") {
            if (data.bname) fullAddress += ` ${data.bname}`;
            if (data.buildingName) fullAddress += `, ${data.buildingName}`;
        }
        setDepart((prev: any) => ({
            ...prev,
            post: data.zonecode,
            address: fullAddress,
        }));
        setShowDepartPostcode(false);
        setErrors(prev => ({ ...prev, departPostcode: false, departAddress: false }));
    };

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="운송장 신청접수" />
            {isPending && <Spinner />}
            <CustomerLayout>
                <div className="flex-1 bg-[#f8f8f8] flex flex-col items-center pt-12 responsive1200:pt-[30px] responsive600:px-[4%] responsive600:bg-white">
                    <p className="text-[#1b1c1e] text-[36px] font-bold responsive1200:text-[24px] responsive1200:font-[500]">
                        운송장 신청접수
                    </p>
                    {accessToken ? (
                        <>
                            <div className="max-w-[1200px] w-full mx-auto my-10 responsive1200:px-[4%] responsive600:px-0">
                                <div className="w-full py-10 bg-white px-10 rounded-[20px] responsive600:px-0">
                                    <p className="text-[24px] font-bold">
                                        최근 신청 내역 <span className="text-[16px] font-normal">(5개 까지)</span>
                                    </p>

                                    {filteredHistory?.length > 0 ? (
                                        <>
                                            <Table
                                                thead={[
                                                    {
                                                        title: "담당자번호",
                                                        width: "14%",
                                                        key: "담당자번호",
                                                        className: "text-[15px] text-[#666] text-center px-2",
                                                    },
                                                    {
                                                        title: "요청사항",
                                                        width: "15%",
                                                        key: "요청사항",
                                                        className: "text-[15px] text-[#666] text-center px-2",
                                                    },
                                                    {
                                                        title: "받을주소",
                                                        width: "21%",
                                                        key: "받을주소",
                                                        className: "text-[15px] text-[#666] text-center px-2",
                                                    },
                                                    {
                                                        title: "내용",
                                                        width: "28%",
                                                        key: "내용",
                                                        className: "text-[15px] text-[#666] text-center px-2",
                                                    },
                                                    {
                                                        title: "상태",
                                                        width: "12%",
                                                        key: "상태",
                                                        className: "text-[15px] text-[#666] text-center px-2",
                                                    },
                                                    {
                                                        title: "신청날짜",
                                                        width: "12%",
                                                        key: "신청날짜",
                                                        className: "text-[15px] text-[#666] text-center px-2",
                                                    },
                                                ]}
                                                tbody={filteredHistory || []}
                                                className="my-[40px]"
                                                totalCount={filteredHistory?.length ?? 0}
                                                currentPage={1}
                                            />

                                        </>
                                    ) : (
                                        <div className="py-10 text-center text-[20px]">최근 신청 내역이 없습니다.</div>
                                    )}
                                </div>
                            </div>

                            <form onSubmit={handleSubmit} className="w-full max-w-[600px]">
                                <div className="bg-white items-center mt-12 p-10 rounded-2xl flex flex-col mb-6 gap-5 responsive1200:mt-[30px] responsive600:px-0 responsive600:py-0 responsive600:mt-[54px]">
                                    <div className="flex items-center w-full responsive600:flex-col responsive600:gap-[8px]">
                                        <div className="text-[18px] font-[500] min-w-[160px] responsive600:self-start responsive600:text-[16px]">
                                            상호명 <span className="text-new text-[16px] font-normal">*</span>
                                        </div>
                                        <Input
                                            value={depart.company}
                                            onChange={e => {
                                                setDepart(prev => ({ ...prev, company: e.target.value }));
                                                setErrors(prev => ({ ...prev, company: false }));
                                            }}
                                            className="w-full"
                                            placeholder="상호명을 입력해주세요."
                                            error={errors.company}
                                        />
                                    </div>
                                    <div className="flex items-center w-full responsive600:flex-col responsive600:gap-[8px]">
                                        <div className="text-[18px] font-[500] min-w-[160px] responsive600:self-start responsive600:text-[16px]">
                                            담당자 번호 <span className="text-new text-[16px] font-normal">*</span>
                                        </div>
                                        <PatternFormat
                                            format="###-####-####"
                                            id="mobile"
                                            name="mobile"
                                            value={depart.mobile}
                                            placeholder="휴대폰 번호를 입력해주세요."
                                            onChange={e => {
                                                setDepart(prev => ({ ...prev, mobile: e.target.value }));
                                                setErrors(prev => ({ ...prev, tel: false }));
                                            }}
                                            className={`
                                        h-[52px] w-full border rounded-lg text-[18px] px-4 outline-0
                                        ${errors.tel ? "border-red-500 border-2" : "border-[#E1E2E4]"}
                                        focus:border-2 focus:border-new
                                    `}
                                        />
                                    </div>
                                    <div className="flex flex-col w-full gap-3 responsive600:gap-[8px]">
                                        <div className="text-[18px] font-[500] responsive600:self-start responsive600:text-[16px]">
                                            요청사항
                                        </div>
                                        <div className="w-full grid grid-cols-3 gap-2 responsive600:grid-cols-2 ">
                                            {visibleSuppliesOptions.map(option => {
                                                const checked = depart[option.key];
                                                return (
                                                    <div
                                                        key={option.key}
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => toggleSupply(option.key)}
                                                        className={`
                                                            relative flex flex-col items-center gap-2 p-2 border rounded-lg cursor-pointer transition-colors
                                                            ${checked ? "border-new bg-new/5" : "border-[#E1E2E4] hover:border-[#1B1C1E]"}
                                                        `}
                                                    >
                                                        <img
                                                            src={option.image}
                                                            alt={option.label}
                                                            className="w-full aspect-square object-contain rounded bg-white"
                                                        />
                                                        <button
                                                            type="button"
                                                            aria-label="이미지 확대"
                                                            onClick={e => {
                                                                e.stopPropagation();
                                                                setPreviewImage({ src: option.image, alt: option.label });
                                                            }}
                                                            className="absolute top-1.5 right-1.5 p-1.5 rounded-full bg-white/90 border border-[#E1E2E4] shadow-sm hover:bg-white cursor-zoom-in"
                                                        >
                                                            <Search className="w-4 h-4" />
                                                        </button>
                                                        <div className="flex items-center gap-1 self-start">
                                                            <CheckBox checked={checked} onChange={() => {}} size="w-5 h-5" />
                                                            <span className="text-[14px] font-[500] text-[#1b1c1e]">{option.label}</span>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    <div className="flex flex-col w-full gap-2 responsive600:flex-col responsive600:gap-[8px]">
                                        <div className="text-[18px] font-[500] min-w-[160px] responsive600:text-[16px]">
                                            받을 주소지 <span className="text-new text-[16px] font-normal">*</span>
                                        </div>
                                        <div className="flex flex-col gap-1.5 relative">
                                            <div className="flex gap-1.5">
                                                <Input
                                                    disabled
                                                    onChange={e => {
                                                        setDepart(prev => ({ ...prev, post: e.target.value }));
                                                        setErrors(prev => ({ ...prev, departPostcode: false }));
                                                    }}
                                                    onClick={() => setShowDepartPostcode(true)}
                                                    className="w-full"
                                                    value={depart.post}
                                                    error={errors.departPostcode}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => setShowDepartPostcode(true)}
                                                    className="min-w-[123px] border rounded-lg border-[#1B1C1E] text-[18px] font-[500]"
                                                >
                                                    우편번호
                                                </button>
                                            </div>

                                            <Input
                                                disabled
                                                onClick={() => setShowDepartPostcode(true)}
                                                value={depart.address}
                                                onChange={e => {
                                                    setDepart(prev => ({ ...prev, address: e.target.value }));
                                                    setErrors(prev => ({ ...prev, departAddress: false }));
                                                }}
                                                error={errors.departAddress}
                                            />
                                            <Input
                                                placeholder="상세주소 입력"
                                                value={depart.addressDetail}
                                                onChange={e => {
                                                    setDepart((prev: any) => ({ ...prev, addressDetail: e.target.value }));
                                                    setErrors(prev => ({ ...prev, departAddressDetail: false }));
                                                }}
                                                error={errors.departAddressDetail}
                                            />
                                            {showDepartPostcode && (
                                                <div className="absolute z-[100] mt-[34px] top-[22px] bg-white border w-full rounded-lg shadow-lg overflow-hidden">
                                                    <div className="px-6 py-5 text-2xl font-bold border-b border-gray3 flex items-center justify-between">
                                                        <p>우편번호 찾기</p>
                                                        <Close onClick={() => setShowDepartPostcode(false)} className="cursor-pointer" />
                                                    </div>
                                                    <DaumPostcodeEmbed className="min-h-[470px]" onComplete={handleDepartAddress} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-2 w-full">
                                        <div className="text-[18px] font-[500] min-w-[160px] responsive600:text-[16px]">내용</div>

                                        <textarea
                                            value={depart.contents}
                                            onChange={e => setDepart(prev => ({ ...prev, contents: e.target.value }))}
                                            className="w-full border rounded-lg text-[18px] py-2 px-4 outline-0 focus:border-2 focus:border-new min-h-[200px]"
                                        />
                                    </div>
                                </div>
                                <Button
                                    size="L"
                                    type="button"
                                    onClick={handleSubmit}
                                    className="w-full max-w-[600px] border-none bg-new text-white mb-16"
                                >
                                    신청 접수
                                </Button>
                            </form>
                        </>
                    ) : (
                        <div className="mt-10 w-full h-[68vh]">
                            <NoLogin status="morning" />
                        </div>
                    )}
                </div>
                {showCompletePop && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="absolute z-[100] mt-[34px] flex flex-col gap-8 bg-white border w-[560px] p-10 rounded-lg shadow-lg overflow-hidden">
                            <div className="text-2xl flex items-center justify-between">
                                <p>신청접수 완료 되었습니다.</p>
                                <Close onClick={() => setShowCompletePop(false)} className="cursor-pointer" />
                            </div>
                            <Button onClick={() => setShowCompletePop(false)} className="w-full border-none bg-new text-white" size="L">
                                확인
                            </Button>
                        </div>
                    </div>
                )}
                {previewImage && (
                    <div
                        className="fixed inset-0 z-[300] bg-black bg-opacity-70 flex items-center justify-center p-4 cursor-zoom-out"
                        onClick={() => setPreviewImage(null)}
                    >
                        <Close
                            onClick={() => setPreviewImage(null)}
                            className="absolute top-6 right-6 cursor-pointer text-white [&>path]:stroke-white"
                        />
                        <img
                            src={previewImage.src}
                            alt={previewImage.alt}
                            onClick={e => e.stopPropagation()}
                            className="max-w-[50vw] max-h-[90vh] object-contain cursor-default"
                        />
                    </div>
                )}
            </CustomerLayout>
        </React.Fragment>
    );
};

export default MorningRequestTracking;
